import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prettifyDate } from '../../../utils/string';
import { get } from 'lodash';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { currencyMapper } from '@nexio/emvio-util-app';
import './BatchesListItem.scss';

export default class BatchesListItem extends Component {
    static propTypes = {
        item: PropTypes.any.isRequired,
        onGoToItem: PropTypes.func.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderMerchant(merchantName) {
        return merchantName ? merchantName : 'No Merchant';
    }

    renderBatchId(batches) {
        return get(batches, 'processor.batchRef', 'No Batch ID');
    }

    render() {
        const batch = this.props.item;

        const currencyCode = get(currencyMapper, batch.currencyId, '840').code;

        return (
            <div className="batches-list-item" onClick={this.props.onGoToItem}>
                <div className="batches-list-item-left">
                    <span className="batches-date">
                        {this.renderDate(batch.closeDate)}
                    </span>
                    <span className="batches-merchant">
                        {this.renderMerchant(batch.merchantName)}
                    </span>
                </div>
                <div className="batches-list-item-right">
                    <span className="batches-amount">
                        <ColorDollarAmountCell amount={batch.settledAmount} currencyCode={currencyCode} />
                    </span>
                    <span className="batches-id">
                        {this.renderBatchId(batch)}
                    </span>
                </div>
            </div>
        );
    }
}
